module.exports = __webpack_public_path__ + "static/media/little-debbie-logo.0a1192c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/OnboardingDemo/assets/little-debbie-logo.png
// module id = 1257
// module chunks = 0